(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/components/search-result.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/components/search-result.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const useOrderHomeContext = svs.ticketsOrderHome.context.useOrderHomeContext;
const CustomerAddressInformationComponent = svs.ticketsOrderHome.orderHome.components.CustomerAddressInformationComponent;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  Icon = _svs$ui.ReactIcon;
const _React = React,
  Fragment = _React.Fragment,
  useState = _React.useState;
const formatReceiver = receiver => ({
  name: receiver.firstName,
  surname: receiver.lastName,
  address: [receiver.careOf, receiver.street].filter(x => x).join(', '),
  postcode: receiver.zipCode,
  location: receiver.city
});
const SPACEBAR_KEY_CODE = 32;
const ENTER_KEY = 13;
const SearchResult = () => {
  var _receiver$details;
  const SearchResultItem = svs.ticketsOrderHome.orderHome.receiver.components.SearchResultItem;
  const _useOrderHomeContext = useOrderHomeContext(),
    receiver = _useOrderHomeContext.state.receiver,
    setReceiver = _useOrderHomeContext.setReceiver;
  const _useState = useState(Math.min(receiver.result.length, 10)),
    _useState2 = _slicedToArray(_useState, 2),
    resultWindow = _useState2[0],
    setResultWindow = _useState2[1];
  const nextResultWindowExpansion = Math.min(10, receiver.result.length - resultWindow);
  const expandResultWindow = () => {
    setResultWindow(resultWindow + nextResultWindowExpansion);
  };
  const onClickResult = r => () => {
    setTimeout(() => {
      setReceiver(_objectSpread(_objectSpread({}, receiver), {}, {
        details: r
      }));
    }, 450);
  };
  const onClickReset = () => setReceiver(_objectSpread(_objectSpread({}, receiver), {}, {
    result: undefined,
    details: undefined
  }));
  const handleKeyDown = onClick => e => {
    if (e.keyCode === SPACEBAR_KEY_CODE || e.keyCode === ENTER_KEY) {
      e.stopPropagation();
      e.preventDefault();
      onClick && onClick();
    }
  };
  return React.createElement(Fragment, null, (_receiver$details = receiver.details) !== null && _receiver$details !== void 0 && _receiver$details.id ? React.createElement(Fragment, null, React.createElement("h4", {
    className: "h4 fw-500"
  }, "Mottagare"), React.createElement(CustomerAddressInformationComponent, {
    className: "padding-bottom-2 margin-bottom-1 border-bottom",
    data: formatReceiver(receiver.details)
  })) : React.createElement(Fragment, null, React.createElement("h4", {
    className: "h4 fw-500 f-content"
  }, "S\xF6kresultat"), React.createElement("p", {
    className: "f-content border-bottom margin-bottom-0 padding-bottom-2"
  }, "V\xE4lj mottagare nedan:"), React.createElement("ul", {
    className: "data-hj-suppress padding-0 margin-bottom-1"
  }, receiver.result.slice(0, resultWindow).map((r, i) => React.createElement(SearchResultItem, {
    index: i,
    key: r.id,
    onClick: onClickResult(r),
    onKeyDown: handleKeyDown(onClickResult(r)),
    result: r
  }))), nextResultWindowExpansion > 0 && React.createElement("div", {
    className: "f-content"
  }, React.createElement("a", {
    className: "margin-top-half margin-bottom-half",
    onClick: expandResultWindow,
    onKeyDown: handleKeyDown(expandResultWindow),
    role: "button",
    tabIndex: 0
  }, "Visa ", nextResultWindowExpansion, " till"))), React.createElement(Button, {
    block: true,
    className: "margin-top-2 margin-bottom-2",
    onClick: onClickReset,
    transparent: true,
    type: "button"
  }, React.createElement(Icon, {
    icon: "search"
  }), "Ny s\xF6kning"));
};
setGlobal('svs.ticketsOrderHome.orderHome.receiver.components.SearchResult', SearchResult);

 })(window);